import React from "react";
import axios from "axios";
import { useState } from "react";
import {BRANCH} from "../../../Constant/Static/config"
import Loader from "../../../Constant/Custom/Loader";
import PopModal from "../../../Constant/Custom/Models/PopModal";
import TNLogo from '../../../Constant/Icons/TamilNadu_Logo.png'
import back from '../../../Constant/Icons/back.svg'
import { serverUrl } from "../../../Constant/Static/config";
import "./vacancy.css";

function Vacancy() {
  const [loading, setLoading] = useState(false);
  const [collegeCode, setCollegeCode] = useState("");
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
  const [onConfirm, setOnConfirm] = useState(() => () => { });

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleSearch = async () => {
    if (!collegeCode) return;
    setLoading(true)
    try {
      const res = await axios.post(`${serverUrl}/api/vacancy-position`, { collegeCode: collegeCode })
      const fetchedData = res.data.vacancyDetails;
      setData(fetchedData);
      if (fetchedData.length > 0) {
        // setInstitutionName(fetchedData[0].INSTITUTION);
      } else {
        // setInstitutionName("");
      }
    } catch (err) {
      // if(err.response.status)
      if (err.status === 404) {
        setModalType({
          icon: 'error',
          title: 'Not found',
          text: 'Invalid College Code..!'
        })
      }
      openModal();
      setOnConfirm(() => closeModal)
      setData([]);
      setCollegeCode('')
      // setInstitutionName("");
    } finally {
      setLoading(false)
    }
  };

  const columnHeaders = [
    { key: "BRANCH", label: "Branch Code" },
    { key: "OC", label: "OC" },
    { key: "BC", label: "BC" },
    { key: "BCM", label: "BCM" },
    { key: "MBC", label: "MBC" },
    { key: "SC", label: "SC" },
    { key: "SCA", label: "SCA" },
    { key: "ST", label: "ST" },
    { key: "TOTAL", label: "Total" },
  ];

  if (loading) {
    return <Loader />
  }

  return (
    <div>
      <div className="header">
        <div className='logo'>
          <a href='http://localhost:3000'>
            <img alt='TN' src={TNLogo} width={50} height={50}></img>
          </a>
        </div>
        <div className='header-content'>
          <h3>GOVERNMENT OF TAMILNADU</h3>
          <h4>DIRECTORATE OF TECHNICAL EDUCATION</h4>
          <h4>Tamilnadu Lateral Entry Direct Second Year B.E/B.Tech., Admissions - 2025</h4>
        </div>
        <div className='profile'>
          <a href='/'>
            <img src={back} alt='Login' width={50} height={50} />
          </a>
        </div>
      </div>
      <div className="vac-pos-header-container">
        <h2 className="vac-pos-header-title">VACANCY POSITION AFTER ROUND 2</h2>
      </div>
      <div className="vac-pos-whole-cont">
        <label className="vac-pos-cont-label">Enter College Code</label>
        <input
          type="text"
          value={collegeCode}
          className="vac-pos-cont-input"
          onChange={(e) => setCollegeCode(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSearch();
            }
          }}
        />
        <button type="button" className="vac-pos-cont-button" onClick={handleSearch}>
          Search
        </button>
      </div>

      {data.length > 0 && (
        <div className="vac-pos-college-details-wrapper">
          <div className="vac-pos-college-details">
            <strong>College Code:</strong> {data[0].COLL_CODE} &nbsp; | &nbsp;
            <strong>Institution Name:</strong> {data[0].INSTITUTION}
          </div>
        </div>
      )}

      {data.length > 0 && (

        <div className="vac-pos-divtable">
          <div className="vac-pos-vacancy-row-header">
            <div className="vac-pos-cell header-cell"><strong>SL.NO</strong></div>
            {columnHeaders.map((col, index) => {
              if (col.key === "BRANCH") {
                return (
                  <React.Fragment key={col.key}>
                    <div className="vac-pos-cell header-cell"><strong>{col.label}</strong></div>
                    <div className="vac-pos-cell header-cell"><strong>Branch Name</strong></div>
                  </React.Fragment>
                );
              }
              return (
                <div key={col.key} className="vac-pos-cell header-cell">
                  <strong>{col.label}</strong>
                </div>
              );
            })}
          </div>

          {data.map((row, index) => (
            <div className="vac-pos-vac-row" key={index}>
              <div className="vac-pos-vac-cell">{index + 1}</div>
              <div className="vac-pos-vac-cell">{row.BRANCH}</div>
              <div className="vac-pos-vac-cell">
                {BRANCH.get(row.BRANCH) || "Unknown Branch"}
              </div>
              <div className="vac-pos-vac-cell">{row.OC}</div>
              <div className="vac-pos-vac-cell">{row.BC}</div>
              <div className="vac-pos-vac-cell">{row.BCM}</div>
              <div className="vac-pos-vac-cell">{row.MBC}</div>
              <div className="vac-pos-vac-cell">{row.SC}</div>
              <div className="vac-pos-vac-cell">{row.SCA}</div>
              <div className="vac-pos-vac-cell">{row.ST}</div>
              <div className="vac-pos-vac-cell">{row.COUNTER}</div>
            </div>
          ))}
        </div>
      )}
      <div style={{ position: 'relative', alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <PopModal
          isOpen={isModalOpen}
          type={modalType}
          confirmButtonText="OK"
          onConfirm={onConfirm}
        />
      </div>
    </div>
  );
}

export default Vacancy;
